
/**
 * @param {string} password
 * @returns {Boolean}
 * @detail 输入8-20位密码，字母/数字/符号至少2种
 */
export function validPassword(password) {
  return /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,20}$/.test(password)
}

/**
 * @param {string} mobile
 * @returns {Boolean}
 * @detail 必须大小写字母加数字
 */
export function validMobile(mobile) {
  return /^1\d{10}$/.test(mobile)
}

/**
 * @param {string} cardNumber
 * @returns {Boolean}
 * @detail 验证身份证是否合法
 */
export function validateCardNumber(cardnumber) {
  return /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(cardnumber)
}

/**
 * @param {string} cardNumber
 * @returns {Boolean}
 * @detail 从身份证上读取当前身份证是否是未成年人
 */
export function getAge(cardNumber) {
  const year = cardNumber.substr(6, 4)
  const month = cardNumber.substr(10, 2)
  const day = cardNumber.substr(12, 2)
  const nowDate = new Date()
  let age = ''
  age = nowDate.getFullYear() - year
  if (nowDate.getMonth() + 1 < month) {
    age--
  } else if (nowDate.getMonth() + 1 == month && nowDate.getDate() < day) {
    age--
  }
  return age
}
